"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_web_components_1 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var CharCount = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n  font-size: 12px;\n"], ["\n  text-align: right;\n  font-size: 12px;\n"])));

var StandardInput = function StandardInput(_a) {
  var _b;

  var field = _a.field,
      errors = _a.form.errors,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  required = _a.required,
      info = _a.info,
      label = _a.label,
      charCount = _a.charCount,
      prefix = _a.prefix,
      suffix = _a.suffix,
      props = __rest(_a, ["field", "form", "required", "info", "label", "charCount", "prefix", "suffix"]);

  return react_1.default.createElement(react_1.default.Fragment, null, label ? react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label) : null, react_1.default.createElement("div", null, react_1.default.createElement(react_web_components_1.InputContainer, null, prefix ? react_1.default.createElement(react_web_components_1.InputPrefix, null, prefix) : null, react_1.default.createElement(react_web_components_1.Input, __assign({
    required: required,
    id: field.name,
    name: field.name,
    hasPrefix: !!prefix,
    hasSuffix: !!suffix
  }, props, field)), suffix ? react_1.default.createElement(react_web_components_1.InputSuffix, null, suffix) : null), charCount ? react_1.default.createElement(CharCount, null, ((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) || 0) : null, react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.InputField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: StandardInput
  }));
};

var templateObject_1;